module.exports = __webpack_public_path__ + "img/ch16_05_被袭倒下.e8aa5602.jpg";